import { useWindowWidth } from '@acceso/design-system';

import { DESKTOP_MIN_WIDTH } from '@/constants';

type useUnderMinDesktopWidthProps = {
  underMinDesktopWith: boolean;
};

export function useUnderMinDesktopWidth(): useUnderMinDesktopWidthProps {
  const { width } = useWindowWidth();

  return { underMinDesktopWith: width <= DESKTOP_MIN_WIDTH };
}
